/* Menu Régions + puces d'accueil + carte : tout vient de /collections/all/products.json (Liquid ne sait ni compter par tag ni lister plus de
   quelques tags). Pays et départements absents du HTML Liquid sont ajoutés ici ; nombres, tri par abondance ; drapeaux calculés depuis le tag
   « iso:<CODE> » (indicateurs régionaux Unicode) : aucune liste de pays. Les produits sont partagés avec map.js via window.jpProduits. */
// ponytail: pages de 250 lues l'une après l'autre ; assez pour un catalogue de quelques milliers d'affiches
window.jpProduits = (async () => {
  const tous = [];
  for (let page = 1; ; page++) {
    const { products } = await (await fetch(`/collections/all/products.json?limit=250&page=${page}`)).json();
    for (const p of products) p.tags = Array.isArray(p.tags) ? p.tags : String(p.tags).split(', ');
    tous.push(...products);
    if (products.length < 250) return tous;
  }
})();
(async () => {
  const menus = document.querySelectorAll('[data-regions]');
  if (!menus.length && !document.querySelector('[data-affiches]')) return;
  const compte = {};
  const iso = {};
  let total = 0;
  try {
    for (const p of await window.jpProduits) {
      if (p.tags.includes('type:encadre')) continue; // tous les nombres = affiches (nus) ; l'encadré est le jumeau du nu
      total++;
      const code = (p.tags.find((t) => /^iso:[A-Za-z]{2}$/.test(t)) || '').slice(4).toUpperCase();
      for (const t of p.tags) {
        compte[t] = (compte[t] || 0) + 1;
        if (code && t.startsWith('pays:')) iso[t] = code;
      }
    }
  } catch (e) { return; }
  const esc = (s) => s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
  const handle = (t) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  // [data-affiches] = gabarit avec [n] (data-un si n = 1). Sans data-affiches-filtre : total ; avec : total sur /collections/all, sinon le tag du dernier segment de l'URL
  const seg = location.pathname.startsWith('/collections/all/') ? decodeURIComponent(location.pathname.split('/').filter(Boolean).pop()) : '';
  const tagPage = Object.keys(compte).find((k) => handle(k) === seg);
  document.querySelectorAll('[data-affiches]').forEach((el) => {
    const nb = 'affichesFiltre' in el.dataset ? (/^\/collections\/all\/?$/.test(location.pathname) ? total : compte[tagPage]) : total;
    if (nb != null) el.textContent = (nb === 1 && el.dataset.un ? el.dataset.un : el.dataset.affiches).replace('[n]', nb);
  });
  const n = (el) => compte[(el.dataset.regionsTag ? el : el.querySelector('[data-regions-tag]')).dataset.regionsTag] || 0;
  const trie = (parent, sel) => [...parent.querySelectorAll(`:scope > ${sel}`)].sort((a, b) => n(b) - n(a)).forEach((el) => parent.append(el));
  menus.forEach((menu) => {
    const puces = menu.classList.contains('chips');
    const parent = puces ? menu : menu.querySelector('.regions__panel') || menu;
    const lien = (t) => `href="${esc(menu.dataset.regionsBase + '/' + handle(t))}" data-regions-tag="${esc(t)}"`;
    if (puces && !menu.dataset.regionsCurrent) {
      // current_tags rend la forme handleisée (pays-france) : le tag actif se déduit du dernier segment de l'URL
      const seg = decodeURIComponent(location.pathname.split('/').filter(Boolean).pop() || '');
      const t = Object.keys(compte).find((k) => /^(pays|dept):/.test(k) && handle(k) === seg);
      if (t) {
        menu.dataset.regionsCurrent = t;
        menu.dataset.regionsPaysActif = t.startsWith('dept:') ? `pays:${t.slice(5).split('/')[0]}` : t;
        const toutes = menu.querySelector('.chip:not([data-regions-tag])');
        toutes?.classList.remove('is-active');
        toutes?.removeAttribute('aria-current');
      }
    }
    const present = new Set([...menu.querySelectorAll('[data-regions-tag]')].map((a) => a.dataset.regionsTag));
    const manquants = (prefixe) => Object.keys(compte).filter((t) => t.startsWith(prefixe) && !present.has(t)).sort();
    // pays d'abord : les départements s'accrochent à leur bloc pays
    for (const t of manquants('pays:')) {
      const pays = esc(t.slice(5));
      parent.insertAdjacentHTML('beforeend', puces
        ? `<a class="chip${t === menu.dataset.regionsPaysActif ? ' is-active' : ''}" ${lien(t)} data-regions-pays><span data-regions-flag aria-hidden="true"></span> ${pays} <span data-regions-count></span></a>`
        : `<div class="regions__pays" data-regions-pays><a class="regions__row regions__row--pays" ${lien(t)}><span class="regions__label"><span class="regions__flag" data-regions-flag aria-hidden="true"></span><span>${pays}</span></span><span class="regions__count" data-regions-count></span></a><div class="regions__sous"></div></div>`);
    }
    if (!puces) {
      for (const t of manquants('dept:')) {
        const [pays, ...sous] = t.slice(5).split('/');
        const bloc = [...menu.querySelectorAll('.regions__pays')].find((b) => b.querySelector('[data-regions-tag]').dataset.regionsTag === `pays:${pays}`);
        if (bloc) bloc.querySelector('.regions__sous').insertAdjacentHTML('beforeend', `<a class="regions__row regions__row--sous" ${lien(t)}><span>${esc(sous.join('/'))}</span><span class="regions__count" data-regions-count></span></a>`);
      }
      const titre = menu.querySelector('.regions__title');
      if (titre && menu.dataset.regionsTitle) titre.textContent = menu.dataset.regionsTitle.replace('[count]', Object.keys(compte).filter((t) => t.startsWith('pays:')).length);
    }
    menu.querySelectorAll('[data-regions-tag]').forEach((a) => {
      const c = a.querySelector('[data-regions-count]');
      if (c) c.textContent = compte[a.dataset.regionsTag] || '';
      const f = a.querySelector('[data-regions-flag]');
      if (f && iso[a.dataset.regionsTag]) f.textContent = String.fromCodePoint(...[...iso[a.dataset.regionsTag]].map((l) => 0x1f1a5 + l.charCodeAt(0)));
    });
    if (puces && menu.dataset.regionsPaysActif) {
      // pays actif : clic sur la puce active = retour à « Toutes » ; 2e rangée = ses sous-niveaux (même découpage que le site)
      const pays = menu.dataset.regionsPaysActif;
      const courant = menu.dataset.regionsCurrent;
      const sous = menu.nextElementSibling;
      const base = menu.dataset.regionsBase;
      const chip = menu.querySelector(`[data-regions-tag="${CSS.escape(pays)}"]`);
      chip?.classList.add('is-active');
      chip?.setAttribute('aria-current', 'true');
      if (courant === pays) chip?.setAttribute('href', base);
      const prefixe = `dept:${pays.slice(5)}/`;
      const tags = Object.keys(compte).filter((t) => t.startsWith(prefixe)).sort((a, b) => compte[b] - compte[a] || a.localeCompare(b, 'fr'));
      if (sous && sous.matches('[data-regions-sous]') && tags.length) {
        const [dept, ville] = menu.dataset.regionsNiveaux.split('|');
        sous.querySelector('.regions-sous__label').textContent = pays === 'pays:France' ? dept : ville;
        // sous-niveau actif : second clic = retour au pays (jamais à « Toutes »)
        sous.querySelector('.chips').innerHTML = tags.map((t) => `<a class="chip${t === courant ? ' is-active' : ''}" href="${esc(t === courant ? `${base}/${handle(pays)}` : `${base}/${handle(t)}`)}"${t === courant ? ' aria-current="true"' : ''}>${esc(t.slice(prefixe.length))} <span data-regions-count>${compte[t]}</span></a>`).join('');
        sous.hidden = false;
      }
    }
    menu.querySelectorAll('.regions__sous').forEach((s) => trie(s, '.regions__row'));
    trie(parent, '[data-regions-pays]');
  });
})();
